export default function debounce<T extends (...args: any[]) => void>(
  fn: T,
  timeout: number = 100
): (...args: Parameters<T>) => void {
  let timer: number;

  return (...args: Parameters<T>) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => fn(...args), timeout);
  }
}
